import * as React from 'react';

import QRCode from 'react-qr-code';

import './GenerateQR.css';

class GenerateQR extends React.Component {
	render() {
		return (
			<section className="generateqr">
				<div style={{ height: 'auto', margin: '0 auto', maxWidth: 320, width: '100%' }}>
					<h1>Correct</h1>
					<QRCode
						size={256}
						style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
						value={'CORRECT;' + this.randomString(32)}
						viewBox={`0 0 256 256`}
					/>
					<hr />
					<h1>Error</h1>
					<QRCode
						size={256}
						style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
						value={'ERROR;' + this.randomString(32)}
						viewBox={`0 0 256 256`}
					/>
				</div>
			</section>
		);
	}

	randomString(length) {
		var result = '';
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}
}

export default GenerateQR;
